module.exports = __webpack_public_path__ + "img/1919.c463844a.png";